<template>


  <div class="bg-white rounded relative" ref="form"
    @dragover.prevent
    @dragenter.prevent="dragEnter($event)">


    <form @submit.prevent="addNote()">


      <div class="p-4 bg-alt-white rounded flex border-b border-grey-light">
        <div class="flex items-center">
          <upload-file @uploaded="appendLink" @error="handleUploadError" :isActive="isDropping" @donedrop="() => isDropping = false" />

        </div>
      </div>

      <div class="flex flex-wrap mb-2">
        <div class="w-full">
          <div ref="note" class="note"></div>
        </div>
      </div>

      <div>
        <img :src="img"/>
      </div>

      <p v-if="error" class="text-red-dark py-4 mx-5">{{error}}</p>


      <div class="flex justify-end items-center px-5 border-t border-grey-light bg-grey-lightest rounded py-2">

        <!-- <div>
             <label class="mr-2">Public</label>
             <input type="checkbox" v-model="isPublic" />
             </div> -->

        <div class="flex items-center justify-end">
          <div class="cursor-pointer text-black mr-4" @click="$emit('complete')" v-if="isInModal">
            Cancel
          </div>
          <t-button
            :disabled="noteLen > 4800"
            type="submit"
          >Save</t-button>
        </div>
      </div>
    </form>


  </div>
</template>

<script>
 import editorFactory from '@/editorFactory'
 import UploadFile from '@/components/UploadFile'
 import path from 'path'
 import {mapActions} from 'vuex'
 import eventBus from '@/eventBus'

 import api from '@/api'

 export default {
   props: {
     isFocused: {
       type: Boolean,
       default: false
     },

     isInModal: {
       type: Boolean,
       default: false
     },

     text: {
       type: String,
       default: ''
     }
   },

   components: { UploadFile },

   data () {
     return {
       img: '',
       error: null,
       noteLen: 0,
       isDropping: false,
       file: null,
       isPublic: false
     }

   },

   mounted() {
     this.mountCM();
   },

   methods: {
     ...mapActions(['addRecord']),

     uploadBox () {
       this.$refs.fileElem.click();
     },

     dragEnter () {
       this.isDropping = true
     },

     handleUploadError (err) {
       this.error = err
     },

     appendLink (link) {
       let newNote = `${this.cm.state.doc.toString()}

${link}`

       this.cm.dispatch({
         changes: {from: 0, to: this.cm.state.doc.length, insert: newNote}
       })
     },

     async mountCM () {
       const vm = this;
       this.cm = await editorFactory({
         elm: this.$refs.note,
         text: this.text ? this.text : this.$route.params.path ? path.join('/', this.$route.params.path) + ' ' : '',
         onSubmit: this.addNote,
         onChange: (txt) => { // this also fires immediately...
           this.noteLen = txt.length

           if (this.noteLen > 4800) {
             this.error = `Note is too long. Notes can't be longer than 4800 characters. This one is ${this.noteLen}.`
           } else {
             this.error = ``
           }
         },
       })


       if (this.isFocused) {
         this.cm.focus();
         // this.cm.setCursor(this.cm.lineCount(), 0);
       }

       this.error = '';
     },

     focusEditor() {
       this.cm.focus();
       this.cm.dispatch({selection: {anchor: this.cm.state.doc.toString().length}})
     },

     async addNote () {
       const res = await this.addRecord({
         isPublic: this.isPublic,
         raw: this.cm.state.doc.toString()
       });

       eventBus.$emit('record');

       if (res && res.err) {
         this.error = res.err;
         return;
       }

       this.cm.dispatch({
         changes: {from: 0, to: this.cm.state.doc.length, insert: ''}
       })

       this.$emit('complete');
     }
   }
 }
</script>


<style scoped>
 .note {
   /* min-height: 140px; */
 }

 .is-dropping {

 }

 .drop-overlay {
   background: rgba(255, 255, 255, .9)
 }
</style>
